import { useMemo } from 'react';
import { DefaultTheme } from '@mui/styles';

type paddingType =
  | number
  | {
      top: number;
      bottom: number;
      left: number;
      right: number;
    };

export type domainPaddingType =
  | number
  | { x: [left: number, right: number]; y: [bottom: number, top: number] };
type ChartStylesReturnProps = {
  VictoryChart: {
    height: number;
    padding: paddingType;
  };

  VictoryAxis: {
    tickLabels: {
      fontSize: number;
      fontFamily: string;
    };
  };
};
export const useChartStyles = (theme: DefaultTheme): ChartStylesReturnProps => {
  return useMemo(
    () => ({
      VictoryChart: {
        height: parseInt(theme.spacing(25)),
        padding: { top: 10, bottom: 20, left: 40, right: 10 }
      },
      VictoryAxis: {
        tickLabels: {
          fontSize: 10,
          fontFamily: 'Roboto, Poppins, Helvetica, Segoe UI, Arial, sans-serif'
        }
      }
    }),
    [theme]
  );
};
